export enum SaleDateOption {
  CurrentTimestamp = 'currentTimestamp',
  TimeOfEvent = 'timeOfEvent',
}
